import Heading from "components/Typography/Heading"
import BodyText, { BodyTextProps } from "components/Typography/BodyText"
import styled from "styled-components"
import { FaCircle } from "react-icons/fa"

const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 112px;
  width: 100%;
`

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 4px;

  svg {
    font-size: 8px;
  }
`

const StyledBodyText = styled(BodyText)`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 4px;
`

interface CellStatusProps {
  title?: string
  content?: string
  color?: BodyTextProps["color"]
}

export const CellStatus = (props: CellStatusProps) => {
  const { title, content, color } = props

  return (
    <ContentColumn>
      <Heading variant="xs">{title}</Heading>
      <StatusContainer>
        <StyledBodyText size="xs" weight="semi-bold" color={color}>
          <FaCircle />
          {content}
        </StyledBodyText>
      </StatusContainer>
    </ContentColumn>
  )
}
